/**
 * form.js — the home contact form (Netlify Forms, name "contact"): service · date · guests · name · email · phone · message.
 * (The priced configurators live in builder.js.)
 * - service buttons elsewhere (data-svc="events|consultancy|freelance|coasters") preselect the service
 * - validates name + email, posts via fetch; without JS the form posts to the thank-you page
 */
import { $, $$, reduce, gsap, RT, goTo } from "./core.js";

export function initForm() {
  const form = $("[data-form]");
  if (!form) return;
  const F = RT.form, status = $("#formStatus"), submit = $('button[type="submit"]', form), label = $(".form__label", submit);

  // "Plan je event" / "Boek een shift" … → preselect that service in the form
  document.addEventListener("click", (e) => {
    const a = e.target.closest("[data-svc]"); if (!a) return;
    const r = $(`input[name="dienst"][data-key="${a.dataset.svc}"]`, form);
    if (r) r.checked = true;
  });

  const errs = { naam: $("#f-naam-err"), email: $("#f-email-err") };
  function validate() {
    let first = null;
    for (const n of ["naam", "email"]) {
      const el = form.elements[n], v = el.value.trim();
      let msg = v ? "" : F.required;
      if (!msg && n === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) msg = F.invalidEmail;
      el.setAttribute("aria-invalid", String(!!msg));
      if (msg) el.setAttribute("aria-describedby", errs[n].id); else el.removeAttribute("aria-describedby");
      errs[n].textContent = msg;
      if (msg && !first) first = el;
    }
    if (first) {
      goTo(first, false); first.focus({ preventScroll: true });
      if (!reduce) gsap.fromTo(first, { x: -6 }, { x: 0, duration: 0.4, ease: "elastic.out(1,0.3)" });
    }
    return !first;
  }
  ["naam", "email"].forEach((n) => form.elements[n].addEventListener("blur", () => form.elements[n].getAttribute("aria-invalid") === "true" && validate()));

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (!validate()) return;
    submit.setAttribute("aria-busy", "true"); label.textContent = F.sending;
    status.className = "form__status"; status.textContent = "";
    try {
      const body = new URLSearchParams(new FormData(form)).toString();
      const res = await fetch("/", { method: "POST", headers: { "Content-Type": "application/x-www-form-urlencoded" }, body });
      if (!res.ok) throw new Error(res.status);
      form.classList.add("is-sent");
      status.className = "form__status ok"; status.textContent = F.ok;
      label.textContent = "✓"; submit.disabled = true;
      $$("input,textarea", form).forEach((i) => (i.readOnly = true));
    } catch {
      const text = [...new FormData(form)].filter(([k]) => !["form-name", "bot-field", "taal"].includes(k)).map(([k, v]) => `${k}: ${v}`).join("\n");
      status.className = "form__status bad";
      status.innerHTML = `${F.err} <a href="mailto:${RT.mail}?subject=RHINO&body=${encodeURIComponent(text)}">${RT.mail}</a>`;
      label.textContent = F.submit;
    } finally { submit.removeAttribute("aria-busy"); }
  });
}
